import React from 'react';

import styles from './Progressbar.module.scss';

export interface ProgressbarProps {
  step: number;
  amount: number;
}

function Progressbar({step, amount}: ProgressbarProps) {
  return (
    <div id="progressbar" className={styles.wrapper} data-testid="progressbar">
      <label
        htmlFor="progress"
        className={styles.label}
        aria-labelledby="progress"
        aria-hidden
      >
        {`${step} / ${amount}`}
      </label>
      <progress
        id="progress"
        value={`${step}`}
        max={`${amount}`}
        aria-label={`Etapa ${step} de ${amount}`}
      />
    </div>
  );
}

export default Progressbar;
